export default "__VITE_ASSET__DdYmAIQh__"